import store from "store";
import {
  ANALYTICS_FILTERS,
  ANALYTICS_ACCOUNTS_DATA,
  CONTACT_ANALYTICS,
  CONTENT_ANALYTICS,
  ANALYTICS_ACCOUNTS_DASHBOARD,
  ANALYTICS_CARD_DATA,
  ANALYTICS_DASHBOARD_GRAPH_DATA,
  ANALYTICS_INTENT_DATA,
  ANALYTICS_DASHBOARD,
  ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS,
  ANALYTICS_EMAIL_TRENDS,
  ANALYTICS_CLICK_TRENDS,
} from "constants/types/analyticsTypes";
import { removeCampaignAndEmailQueryParams } from "utils";

export const filterButtonPressed = (isFilterClicked: boolean) => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DATA.RESET,
  });
  store.dispatch({
    type: CONTACT_ANALYTICS.RESET_ALL,
  });
  store.dispatch({
    type: CONTENT_ANALYTICS.RESET,
  });
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DASHBOARD.RESET,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.CLEAR,
  });
  store.dispatch({
    type: ANALYTICS_CARD_DATA.RESET,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.RESET,
  });
  if (isFilterClicked)
    store.dispatch({
      type: ANALYTICS_FILTERS.APPLY,
    });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  store.dispatch({
    type: ANALYTICS_EMAIL_TRENDS.RESET,
  });
  store.dispatch({
    type: ANALYTICS_CLICK_TRENDS.RESET,
  });
  removeCampaignAndEmailQueryParams();
};

export const moveSelectedFiltersToApplied = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET,
  });
};
export const moveAppliedFiltersToSelected = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET,
  });
};

export const filterButtonPressReset = () => {
  store.dispatch({
    type: ANALYTICS_FILTERS.RESET,
  });
};

export const resetRedirectUrls = () => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DATA.RESET_REDIRECT_URL,
  });
  store.dispatch({
    type: CONTACT_ANALYTICS.RESET_REDIRECT_URL,
  });
};

export const updateCampaignLimit = (value: boolean) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_LIMIT,
    payload: value,
  });
};
